<template>
  <div class="infos-video">
    <b-tabs pills nav-class="nav-justified mb-3" content-class="box-branco">
      <b-tab active v-if="referencias.length > 0 || resumos.length > 0">
        <template slot="title">
          <i class="fas fa-folder-plus"></i> Materiais Extras
        </template>

        <materiais-extras :referencias="referencias" :resumos="resumos" />
      </b-tab>
      <b-tab v-if="cadernoLateral && !cadernoLateral.status">
        <template slot="title">
          <i class="fas fa-book-open"></i> Meu Caderno
        </template>

        <meu-caderno :ementa-id="ementaId" :licao="licao" :anotacoes="anotacoes" v-if="cadernoLateral && !cadernoLateral.status" :isVideo="isTopicoVideo"/>
      </b-tab>
      <b-tab v-if="false">
        <template slot="title">
          <i class="far fa-question-circle"></i> Tire suas dúvidas
        </template>

        <jaleko-responde :ementa-id="ementaId" />
      </b-tab>
      <b-tab v-if="$empresaUtils.temAcesso($tipoAcesso.SALA_DE_AULA_TIRE_SUAS_DUVIDAS.nome, $configEmpresa.rotasRestritasAcesso)">
        <template slot="title">
          <i class="far fa-question-circle"></i> Tire suas dúvidas
        </template>

        <relate-uma-duvida :ementa-id="ementaId" />
      </b-tab>
      <b-tab v-if="isTopicoVideo">
        <template slot="title">
          <i class="fas fa-chalkboard-teacher"></i> Professores
        </template>

        <professor :professores="professores" />
      </b-tab>
      <b-tab>
        <template slot="title">
          <i class="fas fa-bug"></i> Relate um problema
        </template>

        <relate-um-problema :ementa-id="ementaId" />
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import MateriaisExtras from './apoio-topico/MateriaisExtras'
import MeuCaderno from './apoio-topico/MeuCaderno'
import Professor from './apoio-topico/Professor'
import RelateUmProblema from './apoio-topico/RelateUmProblema'
import RelateUmaDuvida from './apoio-topico/RelateUmaDuvida'
import JalekoResponde from '@/core/components/JalekoResponde'
import TipoTopico from '@/core/types/tipo-topico-licao'

export default {
  name: 'ApoioTopico',
  components: { JalekoResponde, RelateUmProblema, Professor, MeuCaderno, RelateUmaDuvida, MateriaisExtras },
  props: {
    professores: Array,
    ementaId: Number,
    licao: Object,
    anotacoes: String,
    tipoTopico: Number,
    resumos: Array,
    referencias: Array
  },
  computed: {
    isTopicoVideo: function () {
      return TipoTopico.VIDEO.id === this.tipoTopico
    },
    cadernoLateral: function () {
      return this.$store.getters.caderno_lateral
    }
  }
}
</script>

<style scoped>

</style>
